import { Component, OnInit, inject } from '@angular/core';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';

@Component({
  selector: 'taly-merchant-home',
  templateUrl: './merchant-home.component.html',
  styleUrls: ['./merchant-home.component.scss']
})
export class MerchantHomeComponent  implements OnInit{

  transferSignal = inject(SharedSignalsService);

  constructor(){
    this.transferSignal.setDarkHeader(true)
  }

  ngOnInit(): void {
    this.transferSignal.setDarkHeader(true)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy() {
    this.transferSignal.setDarkHeader(false)
  }

}
